'use strict'

import http from './http-common'
import authHeader from './auth-header'
import useSWR from 'swr'

const findAll = () => {
  return http.axiosClient.get('/devices', { headers: authHeader() })
}

const findById = (id) => {
  return http.axiosClient.get(`/devices/${id}`, { headers: authHeader() })
}

const findNotAssigned = (idRegistry) => {
  return http.axiosClient.get(`/devices/not-assigned/${idRegistry}`, { headers: authHeader() })
}

const create = (data) => {
  return http.axiosClient.post('/devices', data, { headers: authHeader() })
}

const update = (id, data) => {
  return http.axiosClient.patch(`/devices/${id}`, data, {
    headers: authHeader()
  })
}

const remove = (id) => {
  return http.axiosClient.delete(`/devices/${id}`, { headers: authHeader() })
}

export default {
  findAll,
  findById,
  findNotAssigned,
  create,
  update,
  remove
}
